import { IconButton } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import type { TableSettingsField } from "app/pages/sales-intelligence/common-components/export-table/types";
import { NumberInput } from "../../common/NumberInput/NumberInput";
import {
    PRE_DEFINED_CREATE_FIELD,
    PRE_DEFINED_FIELD,
    PRE_DEFINED_UPDATE_FIELD,
    TECHNOGRAPHICS_FIELD,
} from "../../../../../common-components/export-table/const";
import { StyledCheckedBlock, StyledButtonCheckIcon, StyledSelectedCell } from "../styles";

export const SelectedCell = ({
    entry,
    numOfPreDefined,
    numOfPreDefinedCreate,
    numOfPreDefinedUpdate,
    onPreDefinedChange,
    onPreDefinedCreateChange,
    onPreDefinedUpdateChange,
    numOfTechnographics,
    onTechnographicsChange,
    onSelect,
}: {
    entry: TableSettingsField;
    numOfPreDefined: number | string;
    numOfPreDefinedCreate: number | string;
    numOfPreDefinedUpdate: number | string;
    numOfTechnographics: number | string;
    onSelect(entry: TableSettingsField): void;
    onPreDefinedChange(numOfPreDefined: number | string): void;
    onPreDefinedCreateChange(numOfPreDefined: number | string): void;
    onPreDefinedUpdateChange(numOfPreDefined: number | string): void;
    onTechnographicsChange(numOfPreDefined: number | string): void;
}) => {
    const field = entry.similarweb.field;
    const isPreDefined =
        field.includes(PRE_DEFINED_FIELD) &&
        !field.includes(PRE_DEFINED_CREATE_FIELD) &&
        !field.includes(PRE_DEFINED_UPDATE_FIELD);
    const isPreDefinedCreate = field.includes(PRE_DEFINED_CREATE_FIELD);
    const isPreDefinedUpdate = field.includes(PRE_DEFINED_UPDATE_FIELD);
    const isTechnographics = field.includes(TECHNOGRAPHICS_FIELD);
    const translate = useTranslation();

    const wrappedOnChange = (inputValue: number | string) => {
        if (inputValue === 0) {
            return onSelect(entry);
        }

        if (isTechnographics) {
            onTechnographicsChange(inputValue);
        } else if (isPreDefinedCreate) {
            onPreDefinedCreateChange(inputValue);
        } else if (isPreDefinedUpdate) {
            onPreDefinedUpdateChange(inputValue);
        } else {
            onPreDefinedChange(inputValue);
        }
    };

    const wrappedOnClick = () => {
        onSelect(entry);
    };

    const renderSelected = () => {
        if (entry.selected) {
            return (
                <>
                    {isPreDefined ? (
                        <NumberInput
                            value={numOfPreDefined}
                            onChange={wrappedOnChange}
                        />
                    ) : null}
                    {isPreDefinedCreate ? (
                        <NumberInput
                            value={numOfPreDefinedCreate}
                            onChange={wrappedOnChange}
                        />
                    ) : null}
                    {isPreDefinedUpdate ? (
                        <NumberInput
                            value={numOfPreDefinedUpdate}
                            onChange={wrappedOnChange}
                        />
                    ) : null}
                    {isTechnographics ? (
                        <NumberInput
                            value={numOfTechnographics}
                            onChange={wrappedOnChange}
                        />
                    ) : null}
                    <StyledCheckedBlock className="checked-icon-block">
                        <PlainTooltip
                            appendTo=".checked-icon-block"
                            placement="top"
                            tooltipContent={translate("si.management.sf.settings_export.settings.btn.selected.tooltip")}
                        >
                            <div>
                                <StyledButtonCheckIcon
                                    type="flat"
                                    iconName="checked"
                                    iconSize="xs"
                                    onClick={wrappedOnClick}
                                />
                            </div>
                        </PlainTooltip>
                    </StyledCheckedBlock>
                </>
            );
        }

        return (
            <IconButton
                type="flat"
                iconSize="xs"
                iconName="add"
                onClick={wrappedOnClick}
            >
                {translate("si.management.sf.settings_export.settings.btn.add")}
            </IconButton>
        );
    };

    return <StyledSelectedCell>{renderSelected()}</StyledSelectedCell>;
};
